import { render, staticRenderFns } from "./championSay.vue?vue&type=template&id=4613bfa9&"
import script from "./championSay.vue?vue&type=script&lang=js&"
export * from "./championSay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports